/** @format */

import { createSlice } from '@reduxjs/toolkit';

const pdfAddedRemovedCoordSlice = createSlice({
  name: "pdfAddedRemovedCoord",
  initialState: {
    addedCoordinatesData: [], // Array to store added coordinates
    removedCoordinatesData: [], // Array to store removed coordinates
    modifiedCoordinates: [], // Array to store both added or removed coordinates
    modifiedCoordinatesRedo: [], // Array to store both added or removed coordinates for REDO.
  },
  reducers: {
    // Action to add a coordinate to the addedCoordinatesData array
    addedCoordinateFunc(state, action) {
      const { payload } = action;
      // Push the coordinate into the addedCoordinatesData array
      state.addedCoordinatesData.push(payload);
    },

    modifiedCoordinateFunc(state, action) {
      const { payload } = action;
      // Push the coordinate into the addedCoordinatesData array
      state.modifiedCoordinates.push(payload);
    },

    modifiedCoordinateUndoFunc(state, action) {
      // Check if modifiedCoordinates is not empty
      if (state.modifiedCoordinates.length > 0) {
        // Pop the last item from modifiedCoordinates (this mutates the state)
        const removedItem = state.modifiedCoordinates.pop();

        // Push the removed item into modifiedCoordinatesRedo (this also mutates the state)
        state.modifiedCoordinatesRedo.push(action?.payload);
      }
    },
    modifiedCoordinateRedoFunc(state, action) {
      // Check if modifiedCoordinates is not empty
      if (state.modifiedCoordinatesRedo.length > 0) {
        // Pop the last item from modifiedCoordinates (this mutates the state)
        const removedItem = state.modifiedCoordinatesRedo.pop();

        // Push the removed item into modifiedCoordinatesRedo (this also mutates the state)
        state.modifiedCoordinates.push(action.payload);
      }
    },

    // Action to add a coordinate to the removedCoordinatesData array
    removedCoordinateFunc(state, action) {
      const { payload } = action;
      // Push the coordinate into the removedCoordinatesData array
      state.removedCoordinatesData.push(payload);
    },

    // Action to reset all coordinates in both arrays
    resetCoordinatesFunc(state) {
      state.addedCoordinatesData = [];
      state.removedCoordinatesData = [];
    },

    // Action to update a specific coordinate in the addedCoordinatesData array
    updateAddedCoordinateFunc(state, action) {
      const { id, newValue } = action.payload;
      state.addedCoordinatesData = state.addedCoordinatesData.map(
        (coordinate) =>
          coordinate.id === id ? { ...coordinate, ...newValue } : coordinate
      );
    },

    // Action to reset the removed coordinates if needed
    resetRemovedCoordinatesFunc(state) {
      state.removedCoordinatesData = [];
    },
  },
});

export const {
  addedCoordinateFunc,
  modifiedCoordinateFunc,
  modifiedCoordinateUndoFunc,
  modifiedCoordinateRedoFunc,
  removedCoordinateFunc,
  resetCoordinatesFunc,
  updateAddedCoordinateFunc,
  resetRemovedCoordinatesFunc,
} = pdfAddedRemovedCoordSlice.actions;

export default pdfAddedRemovedCoordSlice.reducer;
